var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt2-position-picker"},_vm._l((_vm.allPositions),function(p){return _c('position',{key:p,attrs:{"id":p,"selected":_vm.isSelected(p)},on:{"selected":_vm.select}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }